import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const CashierReport = {
	name: NAME,
	router,
	apiProvider,
};
